import { OrganizationService } from './../../../services/organization.service';
import { UtilityService } from './../../../services/utility.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: '[setup-account]',
  template: require('./setup-account.component.pug'),
  styles: [require('./setup-account.component.css').toString()],
})
export class SetupAccountComponent implements OnInit, OnDestroy {
  name: string = '';
  website: string = '';
  size: any = null;
  role: any = null;
  role_other: string = '';
  clients: any = null;
  customers: any = null;
  referral: any = null;
  extra: string = null;
  affiliate: string = null;

  roleList = [
    { id: 'ceo', name: 'CEO / Founder' },
    { id: 'sales', name: 'Sales / Business Development' },
    { id: 'marketing', name: 'Marketing / Communication' },
    { id: 'consultant', name: 'Consultant / Freelancer' },
    { id: 'code', name: 'Coding / Developer' },
    { id: 'va', name: 'Virtual Assistant' },
    { id: 'other', name: 'Other' },
  ];

  customerList = [
    { id: '0', name: 'None yet' },
    { id: '1-5', name: '1-5 customers' },
    { id: '6-10', name: '2-10 customers' },
    { id: '11-50', name: '11-50 customers' },
    { id: '51-100', name: '51-100 customers' },
    { id: '101-200', name: '101-200 customers' },
    { id: '201-500', name: '201-500 customers' },
    { id: '501-1000', name: '501-1,000 customers' },
    { id: '1001-2000', name: '1,001-2,000 customers' },
    { id: '2001-3000', name: '2,001-3,000 customers' },
    { id: '3001-5000', name: '3,001-5,000 customers' },
    { id: '5001-10000', name: '5,001-10,000 customers' },
    { id: '10001', name: '10,001+ customers' },
    { id: '?', name: "I really don't know" },
  ];

  sizeList = [
    { id: '0', name: 'No company yet' },
    { id: '1', name: 'Just me for now' },
    { id: '2-10', name: '2-10 employees' },
    { id: '11-50', name: '11-50 employees' },
    { id: '51-200', name: '51-200 employees' },
    { id: '201-500', name: '201-500 employees' },
    { id: '501-1000', name: '501-1,000 employees' },
    { id: '1001-5000', name: '1,001-5,000 employees' },
    { id: '5001-10000', name: '5,001-10,000 employees' },
    { id: '10001', name: '10,001+ employees' },
  ];

  clientList = [
    { id: '0-1', name: '0-1 client' },
    { id: '2-10', name: '2-10 clients' },
    { id: '11-20', name: '11-20 clients' },
    { id: '21-40', name: '21-40 clients' },
    { id: '41-60', name: '41-60 clients' },
    { id: '61-100', name: '61-100 clients' },
    { id: '101', name: '101+ clients' },
  ];

  referralList = [
    {
      id: 'google',
      name: 'Google Search',
      extra: 'Do you remember what you searched for by any chance?',
    },
    {
      id: 'friend',
      name: 'Friend / Colleague',
      extra: 'Who is this awesome person? So we can thank him/her',
    },
    {
      id: 'course',
      name: 'Course / Program',
      extra: 'What kick ass program is that? So we can thank the author',
    },
    {
      id: 'youtube',
      name: 'YouTube',
      extra:
        'Sweet. What kick ass channel mentioned us? Seems worth watching',
    },
    {
      id: 'blog',
      name: 'Blog / Article',
      extra: "What's the link? Sounds worth a read",
    },
    {
      id: 'podcast',
      name: 'Podcast',
      extra: 'What kick ass podcast mentioned us? Sounds worth listening to',
    },
    {
      id: 'quora',
      name: 'Quora',
      extra: 'Remember the question or, better yet, have the link by any chance?',
    },
    {
      id: 'facebook-group',
      name: 'Facebook Group',
      extra: 'What kick ass Facebook group mentioned us?',
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      extra: 'Nice. Remember who was posting?',
    },
    {
      id: 'twitter',
      name: 'Twitter',
      extra:
        'Remember who or, even better, have the tweet by any chance?',
    },
    {
      id: 'other',
      name: 'Other',
      extra: 'Ok, what did we miss on our list?',
    },
  ];
  routesub: any = null;

  // -------------------------------------------------------------------
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService,
    private cookieService: CookieService,
  ) {}

  account_type: string;
  orgId: string;

  // -------------------------------------------------------------------
  ngOnInit() {
    this.routesub = this.route.paramMap.subscribe(params => {
      this.account_type = params.get('account_type');
      this.orgId = params.get('org_id');

      this.affiliate = this.cookieService.get('_fprom_track');
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  isFormValid() {
    if (!this.name) {
      return false;
    }

    if (!this.website) {
      return false;
    }

    if (!this.size) {
      return false;
    }

    if (!this.role) {
      return false;
    }
    if (this.role.id == 'other' && !this.role_other) {
      return false;
    }

    if (!this.clients && this.account_type == 'agency') {
      return false;
    }

    if (!this.customers && this.account_type == 'team') {
      return false;
    }

    if (this.affiliate) {
      return true;
    }

    if (!this.referral) {
      return false;
    }

    if (!this.extra) {
      return false;
    }

    return true;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.router.navigate(['/signup']);
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let client_id = null;
    if (this.clients) {
      client_id = this.clients.id;
    }
    let customer_id = null;
    if (this.customers) {
      customer_id = this.customers.id;
    }

    let refid = null;
    let refextra = null;
    if (this.referral) {
      refid = this.referral.id;
      refextra = this.extra;
    }

    this.utilityService.completeSetup(
      this.orgId,
      this.name,
      this.website,
      client_id,
      customer_id,
      this.size.id,
      refid,
      refextra,
      this.affiliate,
      this.role.id,
      this.role_other,
      res => {
        if (res.skipBilling) {
          this.router.navigate(['/org/' + this.orgId]);
        } else {
          this.router.navigate(['/setup/billing/' + this.orgId]);
        }
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  referralChanged(referral) {
    this.referral = referral;
  }
  // -------------------------------------------------------------------
  sizeChanged(size) {
    this.size = size;
  }
  // -------------------------------------------------------------------
  roleChanged(role) {
    this.role = role;
  }
  // -------------------------------------------------------------------
  clientChanged(clients) {
    this.clients = clients;
  }
  // -------------------------------------------------------------------
  customerChanged(customers) {
    this.customers = customers;
  }
}
